export enum ConnectorsCount {
  NO_OF_CONNECTORS = 12
}

export const NOT_USED_CONNECTORS = {
  connectors: ['servicenow', 'namely', 'sagefinancials', 'sageintacct']
};

export const CONNECTORS_WITH_INITIAL_SETUP = ['computerease', 'vantagepoint'];
